/*global chrome*/

import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser, getAccessToken, resetUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';
import ProblematicLogEntry from './ProblematicLogEntry';
import AudioRecorder from './AudioRecorder'
import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import IframeWeb from './IframeWeb'
import Loading from './Loading'
import logoBold from './assets/logoBold.png';

import BrowserNotifications from "./BrowserNotifications";
import { FailureReasonsTextField, TimeSpentSelect, WorkoutTimeSelect, TimeCommitmentSelect, TreatmentsSelect, CaplanScaleNO3Slider, CaplanScaleNO2Slider, CaplanScaleNO1Slider, CaplanScaleCIU3Slider, CaplanScaleCIU2Slider, CaplanScaleCIU1Slider, CaplanScaleCP3Slider, CaplanScaleCP2Slider, CaplanScaleCP1Slider, CaplanScaleMR3Slider, CaplanScaleMR2Slider, CaplanScaleMR1Slider, CaplanScalePOSI1Slider, CaplanScalePOS2Slider, CaplanScalePOS3Slider,  GoalTextField, ProblematicBehaviorsSelect, JoiningReasonSelect, GenderSelect, DOBDatePicker, MateriaBasicTextField, LandingName } from './MaterialComponents';

import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';
import './css/Landing.css';

import closeBttn from './assets/closeBttnSquare.svg';
import nextBttn from './assets/nextBttn.svg';



//TODO: move this to an environment variable
const landingUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/landing';


const LandingForm = () => {
    const user = getUser();
    const token = getAccessToken();
    // const name = user !== 'undefined' && user ? user.name: '';
    const username = user !== 'undefined' && user ? user.username: '';

    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [dailyContent, setDailyContent] = useState('');


    //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [showonboardingPopup, setShowonboardingPopup] = useState(false);
    
    const [journalAudio, setAudio] = useState(null);

    const navigate = useNavigate()

    //Onboarding Log 
    const [onboardingIntro, setonboardingIntro] = useState('');
    const [onboardingTime, setonboardingTime] = useState('');
    const [onboardingBackground, setonboardingBackground] = useState('');
    const [onboardingInformation, setonboardingInformation] = useState('');
    const [onboardingScreenStart, setOnboardingScreenStart]= useState('');
    const [onboardingWhy, setonboardingWhy] = useState('');
    const [onboardingImpact, setonboardingImpact] = useState('');
    const [onboardingScreen, setOnboardingScreen] = useState('');
    const [onboardingScreen2, setOnboardingScreen2] = useState('');
    const [onboardingScreen3, setOnboardingScreen3] = useState('');
    const [onboardingScreen4, setOnboardingScreen4] = useState('');
    const [onboardingSuccess, setonboardingSuccess] = useState('');
    const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
    const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
    const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');



    //Learning Form Data (move it here)
    const [name, setName] = useState('');
        function handleName(newValue) {
            setName(newValue);
    }

    const [dateofbirth, setDateofbirth] = useState('');
    function handleDateofbirth(newValue) {
        setDateofbirth(newValue);
    }

    const [gender, setGender] = useState('');
    let genderCurr = []
    function handleGender(newValue) {
        setGender(newValue);
        genderCurr = newValue
        //console.log('set gender to: ', newValue)
        //console.log('gender now is: ', gender)
    }

    const [email, setEmail] = useState('');
    function handleEmail(newValue) {
        setEmail(newValue);
    }
    

    const [joiningReason, setJoiningReason] = useState('');
    function handleJoiningReason(newValue) {
        setJoiningReason(newValue);
    }

    const [timeSpent, setTimeSpent] = useState('');
    function handleTimeSpent(newValue) {
        setTimeSpent(newValue);
    }

    const [problematicBehaviors, setProblematicBehaviors] = useState('');
    function handleProblematicBehaviors(newValue) {
        setProblematicBehaviors(newValue);
    }

    const [caplanScalePOSI1, setCaplanScalePOSI1] = useState('');
    function handleCaplanScalePOSI1(newValue) {
        setCaplanScalePOSI1(newValue);
    }

    const [caplanScalePOSI2, setCaplanScalePOSI2] = useState('');
    function handleCaplanScalePOSI2(newValue) {
        setCaplanScalePOSI2(newValue);
    }

    const [caplanScalePOSI3, setCaplanScalePOSI3] = useState('');
    function handleCaplanScalePOSI3(newValue) {
        setCaplanScalePOSI3(newValue);
    }

    const [caplanScaleMR1, setCaplanScaleMR1] = useState('');
    function handleCaplanScaleMR1(newValue) {
        setCaplanScaleMR1(newValue);
    }

    const [caplanScaleMR2, setCaplanScaleMR2] = useState('');
    function handleCaplanScaleMR2(newValue) {
        setCaplanScaleMR2(newValue);
    }

    const [caplanScaleMR3, setCaplanScaleMR3] = useState('');
    function handleCaplanScaleMR3(newValue) {
        setCaplanScaleMR3(newValue);
    }

    const [caplanScaleCP1, setCaplanScaleCP1] = useState('');
    function handleCaplanScaleCP1(newValue) {
        setCaplanScaleCP1(newValue);
    }

    const [caplanScaleCP2, setCaplanScaleCP2] = useState('');
    function handleCaplanScaleCP2(newValue) {
        setCaplanScaleCP2(newValue);
    }

    const [caplanScaleCP3, setCaplanScaleCP3] = useState('');
    function handleCaplanScaleCP3(newValue) {
        setCaplanScaleCP3(newValue);
    }

    const [caplanScaleCIU1, setCaplanScaleCIU1] = useState('');
    function handleCaplanScaleCIU1(newValue) {
        setCaplanScaleCIU1(newValue);
    }

    const [caplanScaleCIU2, setCaplanScaleCIU2] = useState('');
    function handleCaplanScaleCIU2(newValue) {
        setCaplanScaleCIU2(newValue);
    }

    const [caplanScaleCIU3, setCaplanScaleCIU3] = useState('');
    function handleCaplanScaleCIU3(newValue) {
        setCaplanScaleCIU3(newValue);
    }

    const [caplanScaleNO1, setCaplanScaleNO1] = useState('');
    function handleCaplanScaleNO1(newValue) {
        setCaplanScaleNO1(newValue);
    }

    const [caplanScaleNO2, setCaplanScaleNO2] = useState('');
    function handleCaplanScaleNO2(newValue) {
        setCaplanScaleNO2(newValue);
    }

    const [caplanScaleNO3, setCaplanScaleNO3] = useState('');
    function handleCaplanScaleNO3(newValue) {
        setCaplanScaleNO3(newValue);
    }


    const [triedTreatments, setTriedTreatments] = useState('');
    function handleTriedTreatments(newValue) {
        setTriedTreatments(newValue);
    }

    const [failureReasons, setFailureReasons] = useState('');
    function handleFailureReasons(newValue) {
        setFailureReasons(newValue);
    }

    const [timeCommitment, setTimeCommitment] = useState('');
    function handleTimeCommitment(newValue) {
        setTimeCommitment(newValue);
    }

    const [workoutTime, setWorkoutTime] = useState('');
    function handleWorkoutTime(newValue) {
        setWorkoutTime(newValue);
    }

    const [currentGoal, setCurrentGoal] = useState('');
    function handleCurrentGoal(newValue) {
        setCurrentGoal(newValue);
    }

    //Onboarding Entries
    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');

    //
    const [timeSpendYearText, setTimeSpendYearText] = useState('');
    const [lifetimeSpendText, setLifetimeSpendText] = useState('');
    const [riskFactorText, setRiskFactorText] = useState('');
    const [timeSavedText, setTimeSavedText] = useState('');

    //Spinner
    const loadingSpinner = document.querySelector('.donut');

    
    function setOnboardingForm(){
        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> Trampoline Health is <b>not an app blocker</b>. We help you reconnect with <b>what matters</b>. To do so, we need to learn a bit about you. Please take a moment to fill out this brief form to help us better understand your digital use. With your help, we can craft the <b>perfect program for you</b>! </p>
                </div>
                <div className="formBttnContainer" style={{ bottom:' 5rem'}}>
                    <button className="popupButton" onClick={handleNextQuestion} >Dive in!</button>
                </div>
            </div> 
        )
        setonboardingTime(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Date of Birth</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <DOBDatePicker handleChange={handleDateofbirth}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Name:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <LandingName label="Name" handleChange={handleName}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Email</div>
                    <MateriaBasicTextField label="Email" handleChange={handleEmail}/>
                </div>
                {/* <div>
                    <div className="onboardingQuestion">What ?</div>
                    <JoiningReasonSelect handleChange={handleJoiningReason} label='Where can we help - multiple select' elements={['Decrease Anxiety', 'Improve Well Being ', 'Improve Relationships ', 'Improve Mental Health', 'Improve Physical Health', 'Decrease Loneliness', 'Increase Self-Fulfillment', 'Improve Sleep', 'Improve Productivity']}/>
                </div> */}
            </div> 
        )
        setonboardingBackground(
            <div className="learningFeedback">
                {/* <div>
                    <p className="questionInfo"> Let's dig a little deeper.</p>
                </div> */}
                <div>
                    <div className="onboardingQuestion">Gender</div>
                    <GenderSelect multipleSelect = 'false' label='Gender' elements={['Woman', 'Man', 'Nonbinary', 'Other']} handleChange={handleGender} defaultValue={gender}/>
                </div>
                <div>
                    <div className="onboardingQuestion">How long, on average, do you spend on the internet daily?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TimeSpentSelect  multipleSelect = 'false' handleChange={handleTimeSpent} label='Time' elements={['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" >What is an important goal that your tech use has gotten in the way of?</div>
                    <GoalTextField handleChange={handleCurrentGoal} placeholder='Goal' />
                </div>
            </div> 
        )
        setonboardingInformation(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>  The following section is designed to measure your digital wellness across various dimensions. It may seem repetitive but this is intentional.</p>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>  <b>Instructions:</b> Please rate how much you agree with each statement, from 1 (Definitely Disagree) to 8 (Definitely Agree). </p>
                </div>
            </div> 
        )
        setOnboardingScreenStart(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I have used the Internet to make myself feel better when I’ve felt upset.</div>
                    <CaplanScaleMR3Slider handleChange={handleCaplanScaleMR3} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I prefer online social interaction over face-to-face communication.</div>
                    <CaplanScalePOSI1Slider value = { caplanScalePOSI1 } handleChange={handleCaplanScalePOSI1} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">When offline, I have a hard time trying to resist the urge to go online.</div>
                    <CaplanScaleCIU3Slider handleChange={handleCaplanScaleCIU3} min='1' max='8'/>
                </div>
            </div> 
        )
        setonboardingWhy(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I have missed social engagements or activities because of my Internet use.</div>
                    <CaplanScaleNO2Slider handleChange={handleCaplanScaleNO2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">My Internet use has created problems for me in my life.</div>
                    <CaplanScaleNO3Slider handleChange={handleCaplanScaleNO3} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I prefer communicating with people online rather than face-to-face.</div>
                    <CaplanScalePOS3Slider handleChange={handleCaplanScalePOSI3} min='1' max='8'/>
                </div>
            </div> 
        )
        setonboardingImpact(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I have difficulty controlling the amount of time I spend online.</div>
                    <CaplanScaleCIU1Slider handleChange={handleCaplanScaleCIU1} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I have used the Internet to talk with others when I was feeling isolated.</div>
                    <CaplanScaleMR1Slider handleChange={handleCaplanScaleMR1} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I find it difficult to control my Internet use.</div>
                    <CaplanScaleCIU2Slider handleChange={handleCaplanScaleCIU2} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I think obsessively about going online when I am offline.</div>
                    <CaplanScaleCP3Slider handleChange={handleCaplanScaleCP3} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">Online social interaction is more comfortable for me than face-to-face interaction.</div>
                    <CaplanScalePOS2Slider handleChange={handleCaplanScalePOSI2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">When I haven’t been online for some time, I become preoccupied with the thought of going online.</div>
                    <CaplanScaleCP1Slider handleChange={handleCaplanScaleCP1} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen2(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I would feel lost if I was unable to go online.</div>
                    <CaplanScaleCP2Slider handleChange={handleCaplanScaleCP2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I have used the Internet to make myself feel better when I was down.</div>
                    <CaplanScaleMR2Slider handleChange={handleCaplanScaleMR2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">My internet use has made it difficult for me to manage my life.</div>
                    <CaplanScaleNO1Slider handleChange={handleCaplanScaleNO1} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen3(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">What have you tried?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TreatmentsSelect handleChange={handleTriedTreatments} label='Solution(s) - multiple select' elements={['Therapy', 'App Blockers', 'Support Group', 'Mindfulness', 'Dumb Phone', 'Physical Limiter', 'Nothing Yet', 'Other']}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Why hasn’t what you’ve tried worked long term?</div>
                    <FailureReasonsTextField handleChange={handleFailureReasons} placeholder="Think about what you have tried and why changes haven't stuck" rows="2"/>
                </div>
            </div> 
        )
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your digital use and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion"> How many times a week do you commit to work on your digital health?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion"> At what time do you plan to do your workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime}/>
                </div>
            </div> 
        )
        // const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
        // const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
        // const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                        <p className="questionInfo"> Digital wellness is is a journey not a destination. Analyzing your responses... </p>
                    </div>
                    <div style={{ marginTop: '5rem'}} id='waiting-animation'>
                        <Loading/>
                    </div>
                    <div style={{ marginTop: '5rem', display: 'none', textAlign:'center'}} id='waiting-text' >
                        <h4>Ready to begin? Click next to see results 🥳 ✨.</h4>
                    </div>
                </div>
            </div> 
            
        )
        setOnboardingTimeWasted(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  We calculated you will spend <b>{timeSpendYearText} days</b> looking at screens this year. Looking ahead this means that you will spend </p>
                    <h1 style={{ textAlign: 'center'}} >{lifetimeSpendText} years</h1>
                    <p className="questionInfo">  of your life looking at a screen. What else could you do in <b>40 years</b>?</p>

                </div>
            </div> 
        )
        setOnboardingScreenerResults(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Problematic tech use is linked conditions like <b>anxiety, depression, and obesity</b>. We calculated your risk as </p>
                    <h1 style={{ textAlign: 'center'}} >High</h1>
                    <p className="questionInfo">  considering your responses. Trampoline Health can help you finally make the change.</p>

                </div>
            </div>
        )
        setOnboardingCalltoAction(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  Trampoline can help you recover </p>
                    <h1 style={{ textAlign: 'center'}} >12 years +</h1>
                    <p className="questionInfo">  of your life and more importantly help you <b>fill up that time with what matters.</b></p>

                </div>
                <div className="formBttnContainer" style={{bottom:'4.0rem'}}>
                    <button className="popupButton" onClick={() => {window.open("https://trampolinehealth.circle.so/checkout/trampoline-health", "_blank");}} >Start Free Trial</button>
                    <button style={{ marginTop: '1rem' }} className="popupButton" onClick={() => {window.open("https://www.trampolinehealth.co/", "_blank");}} >Not sure yet? Join Mailing List</button>
                </div>
            </div> 
        )
    }



    function stringToHTML (str) {
        // If DOMParser is supported, use it
        let support = true
        if (!window.DOMParser) support = false;
        let parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            support = false;
        }
        if (support) {
            let parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            //console.log('yo7', dom)
            return doc.body;
        }

        // Otherwise, fallback to old-school method
        var dom = document.createElement('div');
        dom.innerHTML = str;
        //console.log('yooo')
        //console.log('yo7', dom)
        return dom;
    };

    function randomArrVal(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }
    
    //Popup
    let questionsonboarding = [
        {
            question: "Let's Start Your Digital Wellness Journey!",
            assets: onboardingIntro,
            subheading: 'Test',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingTime,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingBackground,
            answers: gender
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingInformation,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingScreenStart,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingWhy,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingImpact,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingScreen,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingScreen2,
        },
        {
            question: 'Building Your Digital Wellness Plan',
            assets: onboardingScreen3,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingSuccess,
        },
         {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingTimeWasted,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingScreenerResults,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingCalltoAction,
        }
    ];

    const handleonboardingSupport = () => {
        //console.log('handling onboarding support')
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "none";
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
    };

    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
        if (currentQuestion === 9){

            //get amount of time and push it over to days this year and years in front of screen
            let timeSpendOptions = ['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']
            let timeSpendEstimates = [3, 7, 12, 15]
            const index = timeSpendOptions.indexOf(timeSpent[0]);

            let numTimeSpent = parseInt(timeSpendEstimates[index])
            let timeSpendYear = Math.ceil((numTimeSpent * 7 * 52 )* (1/24))
            let multiplier = 1/(365)
            let lifetimeSpend = Math.ceil(timeSpendYear * 79 * multiplier)

            //time saved calculations -- improve these in the future
            let timeSavedMulti = 0.3
            let timeSaved = Math.ceil(lifetimeSpend * timeSavedMulti)
            let personalGoal = currentGoal

            setTimeSpendYearText(timeSpendYear)
            setLifetimeSpendText(lifetimeSpend)
            setTimeSavedText(timeSaved)

            //console.log(timeSpent[0])
            //console.log(index)
            //console.log('time spent in day', numTimeSpent)
            //console.log('time spent in week', numTimeSpent * 7)
            //console.log('time spent in year', timeSpendYear)
            //console.log(lifetimeSpend)      
            //sum up all of the form data and see in which range it is
            let caplanScalePOSI1Num = parseInt(caplanScalePOSI1)
            let caplanScalePOSI2Num = parseInt(caplanScalePOSI2)
            let caplanScalePOSI3Num = parseInt(caplanScalePOSI3)
            let caplanScaleMR1Num = parseInt(caplanScaleMR1)
            let caplanScaleMR2Num = parseInt(caplanScaleMR2)
            let caplanScaleMR3Num = parseInt(caplanScaleMR3)
            let caplanScaleCP1Num = parseInt(caplanScaleCP1)
            let caplanScaleCP2Num = parseInt(caplanScaleCP2)
            let caplanScaleCP3Num = parseInt(caplanScaleCP3)
            let caplanScaleCIU1Num = parseInt(caplanScaleCIU1)
            let caplanScaleCIU2Num = parseInt(caplanScaleCIU2)
            let caplanScaleCIU3Num = parseInt(caplanScaleCIU3)
            let caplanScaleNO1Num = parseInt(caplanScaleNO1)
            let caplanScaleNO2Num = parseInt(caplanScaleNO2)
            let caplanScaleNO3Num = parseInt(caplanScaleNO3)
           
            let totalPOSI = caplanScalePOSI1Num+caplanScalePOSI2Num+caplanScalePOSI3Num
            let totalMR = caplanScaleMR1Num+caplanScaleMR2Num+caplanScaleMR3Num
            let totalCP = caplanScaleCP1Num+caplanScaleCP2Num+caplanScaleCP3Num
            let totalCIU = caplanScaleCIU1Num+caplanScaleCIU2Num+caplanScaleCIU3Num
            let totalNO= caplanScaleNO1Num+caplanScaleNO2Num+caplanScaleNO3Num

            let total = totalPOSI + totalMR + totalCP + totalCIU + totalNO
            //console.log('total: ', total)

            let median = 33
            let std = 17.67
            let riskFactor = ''
            if(total < (median-std)){
                setRiskFactorText('Low')
                riskFactor = 'Low'
            }
            if(total => (median-std) && total < median){
                setRiskFactorText('Medium')
                riskFactor = 'Medium'
            }
            if(total >= median && total < (median+std)){
                setRiskFactorText('High')
                riskFactor = 'High'
            }
            if(total >= (median+std)){
                setRiskFactorText('Severe')
                riskFactor = 'Severe'
            }


            //reload the screens
            setOnboardingTimeWasted(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  We calculated you will spend <b>{timeSpendYear} days</b> looking at screens this year. Looking ahead this means that you will spend </p>
                    <h1 style={{ textAlign: 'center'}} >{lifetimeSpend} years</h1>
                    <p className="questionInfo">  of your life looking at a screen. What else could you do in <b>{lifetimeSpend} years</b>?</p>

                </div>
                </div> 
            )
            setOnboardingScreenerResults(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo"> Problematic tech use is linked to conditions like <b>anxiety, depression, and obesity</b>. We calculated your risk as </p>
                        <h1 style={{ textAlign: 'center'}} >{riskFactor}</h1>
                        <p className="questionInfo">  considering your responses. Trampoline Health can help you finally <b>make the change</b>.</p>

                    </div>
                </div>
            )
            setOnboardingCalltoAction(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo">  Trampoline can help you recover </p>
                        <h1 style={{ textAlign: 'center'}} >{timeSaved} years +</h1>
                        <p className="questionInfo">  of your life and more importantly help you <b>fill up that time with what matters</b>, like: {personalGoal.toLowerCase()}</p>

                    </div>
                    {/* <div>
                        <p id="relapseImprovementTextBody"> <b>Insight: </b> {relapseImprovementText} </p>
                    </div> */}
                    <div className="formBttnContainer" style={{bottom:'3.0rem'}}>
                        <button className="popupButton" onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=e2f2991e9f9a593597bf447a402d65dcaef176c1-ee4903c0-c1f6-4331-9d29-d0b6045d29e4", "_blank");}} > Join Trampoline Beta </button>
                        <button style={{ marginTop: '1rem' }} className="popupButton" onClick={() => {window.open("https://www.instagram.com/trampolinehealth", "_blank");}} >Follow our Instagram</button>
                    </div>
                </div> 
            )
            document.getElementsByClassName('popupButtonGroup')[0].style.display = 'none'
            setTimeout(()=>{
                //console.log(document.getElementById('waiting-animation'))
                //console.log(document.getElementById('waiting-text'))
                document.getElementById('waiting-animation').style.display = 'none'
                document.getElementById('waiting-text').style.display = 'block'
                document.getElementsByClassName('popupButtonGroup')[0].style.display = 'flex'
            }, 6500)
        }
        //console.log('status: ', currentQuestion)
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };


    const homeHandler = () => {
        document.getElementById('learningContainer').style.display = 'none'
        document.getElementById('homeContainer').style.display = 'block'
    }


    const handleChatNavigate = () => {
        // Update the input value as the answer for the current question
        //console.log('navigate chat')
        navigate('/chat')
    };

    const handleSubmitLanding= (event) => {
        // //console.log('submitting data to the server')
        // handleNextQuestion()
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }
    
        const requestBody = {
            email: email,
            dateofbirth: dateofbirth,
            name: name,
            timeSpent: timeSpent,
            gender: gender,
            triedTreatments: triedTreatments,
            failureReasons: failureReasons,
            currentGoal: currentGoal,
            caplanScalePOSI1: caplanScalePOSI1,
            caplanScalePOSI2: caplanScalePOSI2,
            caplanScalePOSI3: caplanScalePOSI3,
            caplanScaleMR1: caplanScaleMR1,
            caplanScaleMR2: caplanScaleMR2,
            caplanScaleMR3: caplanScaleMR3,
            caplanScaleCP1: caplanScaleCP1,
            caplanScaleCP2: caplanScaleCP2,
            caplanScaleCP3: caplanScaleCP3,
            caplanScaleCIU1: caplanScaleCIU1,
            caplanScaleCIU2: caplanScaleCIU2,
            caplanScaleCIU3: caplanScaleCIU3,
            caplanScaleNO1: caplanScaleNO1,
            caplanScaleNO2: caplanScaleNO2,
            caplanScaleNO3: caplanScaleNO3,
        }


        //console.log(requestBody)
        axios.post(landingUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            // //console.log('blep')
            // setTimeout(()=>{
            //     navigate('/daily-content')
            //     document.querySelector('.header').style.display = 'block'
            // }, 4000)
            //console.log('success')
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
        handleNextQuestion()
        return

    };

    const handleOpenonboardingPopup = () => {
        setShowPopup(true);
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const handleCloseonboardingPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };


    const renderFormonboarding = () => {
        try{
            const currentQ = questionsonboarding[currentQuestion];
            const { question, options } = currentQ;

            return (
                <div className="formContainer" >
                    <div className="button-group" style={{ float: 'right' }}>
                        {/* <button onClick={handleCloseonboardingPopup}> 
                            <img style={{ width: '9px', height: '10px', paddingTop: '0.2rem' }} src={closeBttn} alt="CloseModalBttn" />
                        </button> */}
                        <button onClick={handleCloseonboardingPopup} style={{border:'none'}}> 
                            <img className="closeBttn" src={closeBttn} alt="CloseModalBttn" />
                        </button>
                    </div>
                    <h2 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '1rem'}}>{question}</h2>
                    {currentQ.assets}
                    <div className="popupButtonGroup">
                    {(currentQuestion > 0 && currentQuestion < questionsonboarding.length - 1) && (
                        // <button className="popupNavigationBttn" onClick={handlePreviousQuestion}>Previous</button>
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    )}
                    {currentQuestion > 0 && currentQuestion < questionsonboarding.length - 2 ? (
                        // <button className="popupNavigationBttn" onClick={handleNextQuestion}>Next</button>
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsonboarding.length - 2 ? (
                        // <button id="onboardingSubmit" className="popupNavigationBttn" onClick={handleSubmitonboarding}>Submit</button>
                        <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleSubmitLanding} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        }
        catch{
            //console.log('someerro yo onboarding')
        }
    };
    
    // End of Popup
    
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const todayString = today.toDateString();

    useEffect(() => {
        setOnboardingForm()
        document.querySelector('.header').style.display = 'none'
     }, []);
 

    return (
        <div className="wrapper" style={{ marginTop: '2.5rem', marginLeft: '1.5rem', marginRight: '1.5rem'}}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer"  id="onboarding-popup"  style={{ display: 'none' }}>{renderFormonboarding()}</div>
            </div>
            <div className="container" id="learningContainer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1rem', paddingTop: '2rem'}}>
                    <img style={{ width: '95%', maxWidth: '415px', marginBottom: '1rem' }} src={logoBold} alt="Example" />
                </div>
                <div style={{ textAlign: 'center'}}>
                    <h2>Phone Use Holding you Back? - Ready to Regain Control? </h2>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', flexWrap: 'wrap', fontSize:'0.8em', textAlign: 'center'}}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding:"0.5rem"}}>
                        <svg class=" mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        <span class="text-lg font-medium" style={{padding:"0.5rem"}}>Create Sustainable Longterm Change</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding:"0.5rem"}}>
                        <svg class=" mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        <span class="text-lg font-medium" style={{padding:"0.5rem"}}>Gain Accountability and Support</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding:"0.5rem" }}>
                        <svg class=" mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        <span class="text-lg font-medium" style={{padding:"0.5rem"}}>Replace the Time with What Matters</span>
                    </div>
                </div>
                <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', position: 'relative', textAlign: 'center', justifyContent: "center", alignItems:'center', marginTop:'1rem' }}>
                    <h6>Changing digital habits is hard but now you're not alone. </h6>
                    <button className="homeBttn" style={{ marginTop:'1rem', background:"#549ACC", maxWidth: "395px", marginBottom:"1rem" }} onClick={handleOpenonboardingPopup}>Get Started 🚀 </button>
                </div>
            </div>
            
        </div>
    )
}


export default LandingForm;
